import domain from "../domain";
import DashCard from "./DashCard";
import AttributionComponent from "./AttributionComponent";
import classes from "./AdminDashboard.module.css";
import DisplayArea from "./DisplayArea";
import { useState, useEffect } from "react";

import ChartDisplayArea1 from "./ChartDisplayArea1";

import FeedbackDisplayArea from "./FeedbackDisplayArea";
import dateMatcher from "../util/dateMatcher";
import ratingFilteration from "../util/ratingFilteration";
import {
  branchDataStillValid,
  getActiveBranchIds,
  getAllBranchIds,
} from "../util/multipleBranch/getActiveBranchId";
import { browseFeedbackBranchwise } from "../util/adminDashboard/browseFeedbackBranchwise";
import { mergeFeedbackData } from "../util/adminDashboard/mergeFeedbackData";
import { repeatCustomer } from "../util/AttributionAnalysis/repeatCustomer";

function getStoredQuestions() {
  return JSON.parse(localStorage.getItem("questions"));
}

function getStoredBranches() {
  return JSON.parse(localStorage.getItem("branches")) ?? [];
}

function getStoredMainData() {
  return JSON.parse(sessionStorage.getItem("mainData")) ?? null;
}

function getStoredTimeRange() {
  return sessionStorage.getItem("timeRange") ?? "7";
}

function getStoredMainDataTimeRange() {
  return sessionStorage.getItem("mainDataTimeRange") ?? "0";
}

function initializeDashboardStorage() {
  if (sessionStorage.getItem("timeRange") == null) {
    sessionStorage.setItem("timeRange", "7");
  }

  if (sessionStorage.getItem("mainDataTimeRange") == null) {
    sessionStorage.setItem("mainDataTimeRange", "0");
  }
}

async function bootstrapStaffRegister() {

  // we fetch staff register from DB and store it in local storage.
  let branchArray = getAllBranchIds();
  console.log("branchArray", branchArray);

  let restaurantId = localStorage.getItem("restaurantId");
  const response = await fetch(`${domain}/api/fetchstaff`, {
    method: "POST",
    body: JSON.stringify({ branchArray }),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const result = await response.json();
  console.log(result);
  // let bId = localStorage.getItem("id");
  // let branches = JSON.parse(localStorage.getItem("branches"));
  
  localStorage.setItem("staffRegister", JSON.stringify(result.result));

  // const questions = getStoredQuestions();
  // const staffReg = JSON.parse(localStorage.getItem("staffRegister"));

  // if (questions != null && staffReg == null) {
  //   const staffRegister = [
  //     {
  //       bId: questions.admin_id,
  //       staffData: questions.staff,
  //     },
  //   ];

  //   localStorage.setItem("staffRegister", JSON.stringify(staffRegister));
  // }
}

// go function is called when questionaire is not present in local storage.
async function go() {
  console.log("Go FUnction")
  let branchIds = getAllBranchIds();

 console.log("branchIds", branchIds);
  let hqRid = localStorage.getItem("hqRid");
  console.log("hqRid", hqRid);
  try {
    //if questions not present in local storage then fetch from DB

    const response = await fetch(`${domain}/api/questions`, {
      method: "post",
      body: JSON.stringify({
      hqRid,
      }),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    console.log(response.status);
    console.log(result);
    if (response.status === 200) {
      if (result !== null) {
        localStorage.setItem("questions", JSON.stringify(result));
      }

   
      return result;
    }

    return null;
  } catch (err) {
    //console.log("hip1");
    //console.log(err);
  }

  return null;
}

export default function AdminDashboard() {
  //console.log("rendering admins dashboard");

  let myError = "";

  const [error, setError] = useState("");

  const [questions, setQuestions] = useState(getStoredQuestions);
  const [branch, setBranch] = useState(getStoredBranches);
  const activeBranches = getActiveBranchIds(branch);

  const [data, setData] = useState(getStoredMainData);

  const [mainDataTimeRange, setMainDataTimeRange] = useState(
    getStoredMainDataTimeRange,
  );

  const [timeRange, settimeRange] = useState(getStoredTimeRange);

  let dateTill = new Date();
  //console.log(timeRange);
  let dataRangeNumeric = +timeRange;

  // let dateFrom = useRef(
  //   new Date(Date.now() - dataRangeNumeric * 24 * 3600 * 1000)
  // );
  const [dateFrom1, setDateFrom] = useState(
    new Date(Date.now() - dataRangeNumeric * 24 * 3600 * 1000),
  );
  // console.log(dateFrom1);

  const [showChart, setShowChart] = useState(true);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [showAttribution, setShowAttribution] = useState(true);
  // const [range, setRange] = useState(7);
  const [ratingFilter, setRatingFilter] = useState("5-");

  // BRanch Selector
  function branchSelector(e) {
    let index = e.target.id;

    setBranch((prev) => {
      let obj = { ...prev[index], isActive: !prev[index].isActive };
      const output = [...prev];
      output[index] = obj;

      localStorage.setItem("branches", JSON.stringify(output));
      return output;
    });
  }

  function timeRangeHandler(e) {
    //console.log("time range changed");

    let v = +e.target.value;

    settimeRange(v);

    sessionStorage.setItem("timeRange", e.target.value);

    let subtractDays = v * 24 * 3600 * 1000;
    // dateFrom.current = new Date(Date.now() - subtractDays);
    setDateFrom(new Date(Date.now() - subtractDays));

    //console.log(dateFrom1);
  }

  async function fetchFeedbacktHandler(e, activeBranches1) {
    setError("");
    let btnText = e.target.innerHTML;

    // Data already cached in session and how much of it we have.
    let existingMainData = JSON.parse(sessionStorage.getItem("mainData")) || [];
    let cachedDays = +mainDataTimeRange; // days of data already available
    let wantedDays = +timeRange; // days the user now wants
    let branchesValid = branchDataStillValid(activeBranches1) === true;

    // Incremental fetch: same branches, we already have some days, and the user
    // simply wants MORE. Then we only pull the missing older slice (e.g. days
    // 8..30) and merge it with what we already have.
    let incremental = branchesValid && cachedDays > 0 && wantedDays > cachedDays;
// console.log("incremental", incremental);
    // dateFrom = far (older) edge of the wanted window: now - wantedDays.
    let dateFrom = dateFrom1.toString();

    // dateTill = near (newer) edge of the slice we must fetch:
    //   full fetch  -> now
    //   incremental -> now - cachedDays (boundary of data we already hold)
    let dateTill1 = incremental
      ? new Date(Date.now() - cachedDays * 24 * 3600 * 1000).toString()
      : dateTill.toString();

    console.log("dateFrom", dateFrom);
    console.log("dateTill1", dateTill1);
    try {
      e.target.innerHTML = "wait...";
      console.log("branhces being passed to fetch feedback", activeBranches1);
      e.target.disabled = true;
      const response = await fetch(`${domain}/api/fetchfeedback`, {
        method: "post",
        body: JSON.stringify({
          dateFrom: dateFrom,
          dateTill: dateTill1,
          branch: activeBranches1,
        }),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      console.log("feedbacks from backend")
      console.log(result);

      // On an incremental fetch, merge the new slice with cached data (dedupe by
      // _id); otherwise the result replaces everything.
      let combined = incremental
        ? mergeFeedbackData(existingMainData, result || [])
        : result || [];

      if (combined.length === 0) {
        setError("0 feedbacks exist, try increasing time range.");
        sessionStorage.setItem("mainData", JSON.stringify([]));
        sessionStorage.setItem("subData", JSON.stringify([]));
      } else {
        setError("");
        sessionStorage.setItem("mainData", JSON.stringify(combined));
        sessionStorage.setItem("subData", JSON.stringify(combined));
        sessionStorage.setItem(
          "branchesWithDataStored",
          JSON.stringify(activeBranches1),
        );
      }

      // to cal and store attribution data
      repeatCustomer(combined);

      sessionStorage.setItem("mainDataTimeRange", timeRange);
      setMainDataTimeRange(timeRange);

      // filtering data as per rating preference after fetching data
      setData(() => {
        if (combined.length > 0)
          return ratingFilteration(combined, ratingFilter);
      });
      e.target.innerHTML = "Fetch";
      e.target.disabled = false;
    } catch (err) {
      e.target.innerHTML = "Fetch";
      e.target.disabled = false;
      console.log(err);
      setError("Not able to Connect to Internet");
      myError = "Some Error Occured while Fetching";
    }
  }

  function showFeedbacktHandler() {
    setError("");
    //console.log("show button hit");
    // in this we will filter data from main data
    let dFrom = dateFrom1;
    let dTill = dateTill;

    //console.log(dateFrom1, dateTill);
    let mainData1 = JSON.parse(sessionStorage.getItem("mainData"));
    // console.log(mainData1);
    // below is filteration based on TimeRange
    //console.log(mainData1);
    let newData = mainData1?.filter((item) => {
      // console.log(dateMatcher(item.createdAt, dFrom, dTill));

      // below dateMatcher returns true if item.createdAt falls between
      // dFrom and Dtill dates. and Filter function sends those items in
      // newData object if dateMatcher returns true.
      return dateMatcher(item.createdAt, dFrom, dTill);
    });

    if (newData.length == 0) {
      setError("0 feedback to show. kindly change the filters.");
    }
    if (newData != undefined)
      sessionStorage.setItem("subData", JSON.stringify(newData));

    //console.log(newData);

    // to cal and store attribution data
    repeatCustomer(newData);

    // Below is filteration based on rating
    setData((prev) => {
      if (newData?.length > 0) return ratingFilteration(newData, ratingFilter);
    });
  }

  function ratingFilterHandler(e) {
    //console.log("rating changed");
    let v = e.target.value;
    //console.log(v);
    setRatingFilter(v);
  }

  const showBtn = <button onClick={showFeedbacktHandler}>Fetch</button>;
  let btn = <button onClick={showFeedbacktHandler}>Show</button>;

  if (+mainDataTimeRange < +timeRange) {
    btn = (
      <button onClick={(e) => fetchFeedbacktHandler(e, activeBranches)}>
        Fetch
      </button>
    );
  }

  if (branchDataStillValid(activeBranches) != true)
    btn = (
      <button onClick={(e) => fetchFeedbacktHandler(e, activeBranches)}>
        Fetch
      </button>
    );

  function viewToggleHandler(e) {
    console.log(e.target.value);
    let v = e.target.value;
    if (v == "chart") {
      setShowChart((prev) => {
        return !prev;
      });
    }
    if (v == "FeedbackForm") {
      setShowFeedbackForm((prev) => {
        return !prev;
      });
    }
    if (v == "attribution") {
      setShowAttribution((prev) => {
        return !prev;
      });
    }
  }
  //console.log(sessionStorage.getItem("timeRange"));
  // STEPS TO GET array of indices and adminId in data to access first feedback branchwise

  let feedbackCounterIndex = browseFeedbackBranchwise(data, activeBranches);

  useEffect(() => {
    initializeDashboardStorage();
    bootstrapStaffRegister();

    if (getStoredQuestions() == null) {
      go().then((freshQuestions) => {
        if (freshQuestions != null) {
          setQuestions(freshQuestions);
        }
      });
    }
  }, []);
  return (
    <>
      <div className={classes.container}>
        <DashCard>
          <div className={classes.rightContainer}>
            <div className={classes.errorContainer}>{error}</div>
            <div className={classes.branchContainer}>
              {branch.length > 1 &&
                branch.map((b, index) => {
                  return (
                    <div key={`fd${index}`}>
                      <input
                        type="checkbox"
                        id={`${index}`}
                        name={`${b.shortName}`}
                        value={`${b.shortName}`}
                        onChange={(e) => {
                          branchSelector(e);
                        }}
                        checked={branch[`${index}`].isActive}
                      ></input>
                      <label
                        htmlFor={`${b.shortName}`}
                      >{`${b.shortName}`}</label>
                      <br />
                    </div>
                  );
                })}
            </div>
            <div className={classes.rightInnerContainer}>
       
              <div className={classes.verticalContainer}>
                <h4>Time Range</h4> <br></br>
                <select
                  onChange={timeRangeHandler}
                  defaultValue={timeRange}
                  name="range"
                  id="cars"
                >
                  <option value="1">1 Day</option>
                  <option value="2">2 Days</option>
                  <option value="3">3 Days</option>
                  <option value="5">5 Days</option>
                  <option value="7">1 week</option>
                  <option value="14">2 week</option>
                  <option value="30">1 Month</option>
                  <option value="90">3 Months</option>
                </select>
              </div>
              <div className={classes.verticalContainer}>
                <h4>Rating Filter</h4> <br></br>
                <select
                  onChange={ratingFilterHandler}
                  defaultValue="All"
                  name="range"
                  id="cars"
                >
                  <option value="5-">ALL</option>
                  <option value="5*">5 Star</option>

                  <option value="4+">4 & above</option>
                  <option value="4*">4 Star</option>
                  <option value="4-">4 & below</option>
                  <option value="3+">3 & above</option>
                  <option value="3*">3 Star</option>
                  <option value="3-">3 & below</option>
                  <option value="2+">2 & above </option>
                  <option value="2*">2 Star</option>
                  <option value="2-">2 & below</option>

                  <option value="1*">1 Star</option>
                </select>
              </div>
            </div>
            {btn}
            <div className={classes.toggleContainer}>
              <input
                type="checkbox"
                id="v1"
                name="v1"
                value="attribution"
                onChange={viewToggleHandler}
                checked={showAttribution}
              />
              <label htmlFor="v1"> Attribution</label>
              <br></br>
              <input
                type="checkbox"
                id="v2"
                name="v2"
                value="FeedbackForm"
                onChange={viewToggleHandler}
                checked={showFeedbackForm}
              />
              <label htmlFor="v2"> FeedBack Forms</label>
              <br></br>

              <input
                type="checkbox"
                id="v3"
                name="v3"
                value="chart"
                onChange={viewToggleHandler}
                checked={showChart}
              />

              <label htmlFor="vehicle2"> Charts</label>
              <br></br>
            </div>
          </div>
        </DashCard>
      </div>
      <div> {showAttribution && <AttributionComponent />}</div>
      {showFeedbackForm && (
        <div>
          <FeedbackDisplayArea
            data={data}
            feedbackIndex={feedbackCounterIndex}
          />
        </div>
      )}

      {showChart && (
        <div id="pie1">
          {/* <ChartDisplayArea data={data} qdata={questions} /> */}
          <ChartDisplayArea1 data={data} qdata={questions} />
        </div>
      )}

      <br></br>
    </>
  );
}
